import React from 'react';
import './portlet.css';

const activeBadge = (value) => {
  const isActive = value === true || value === 1 || value === '1' || value === 'true';
  return <span className={`mgr-badge ${isActive ? 'mgr-badge-active' : 'mgr-badge-inactive'}`}>{isActive ? '활성' : '비활성'}</span>;
};

function ValueRow({ label, children }) {
  return <tr><th>{label}</th><td>{children}</td></tr>;
}

function PortletDetail({ portlet, onEdit, onDelete }) {
  if (!portlet) return <div className="mgr-right-empty"><span>포틀릿을 선택하세요.</span></div>;

  return (
    <>
      <div className="mgr-panel-header">
        <div>
          <div className="mgr-panel-title">포틀릿 조회</div>
          <div className="mgr-panel-subtitle">{portlet.portlet_label}</div>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-sm btn-outline-primary" onClick={() => onEdit && onEdit(portlet)}>수정</button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete && onDelete(portlet)}>삭제</button>
        </div>
      </div>
      <div className="mgr-panel-body">
        <table className="mgr-detail-table">
          <tbody>
            <ValueRow label="포틀릿 ID">{portlet.portlet_id || '-'}</ValueRow>
            <ValueRow label="포틀릿 라벨">{portlet.portlet_label || '-'}</ValueRow>
            <ValueRow label="포틀릿 설명">
              <div style={{ whiteSpace: 'pre-wrap' }}>{portlet.portlet_context || '-'}</div>
            </ValueRow>
            <ValueRow label="정렬 순서">{portlet.sort_order ?? '-'}</ValueRow>
            <ValueRow label="활성 상태">{activeBadge(portlet.is_active)}</ValueRow>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default PortletDetail;
